<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <v-row>
      <v-col
        cols="12"
        class="buttons__container"
      >
        <div class="buttons__mode">
          <v-btn
            id="graph"
            :class="{ primary: mode === 'graph' }"
            @click="mode = 'graph'"
          >
            <v-icon>mdi-chart-bar</v-icon>
          </v-btn>
          <v-btn
            id="table"
            :class="{ primary: mode === 'table' }"
            @click="mode = 'table'"
          >
            <v-icon>mdi-table-large</v-icon>
          </v-btn>
        </div>
        <div class="buttons__time">
          <v-btn
            id="one_month"
            :class="{ primary: selection === 'one_day' }"
            @click="updateData('one_day')"
          >
            {{ $vuetify.lang.t('$vuetify.day') }}
          </v-btn>
          <v-btn
            id="one_week"
            :class="{ primary: selection === 'one_week' }"
            @click="updateData('one_week')"
          >
            {{ $vuetify.lang.t('$vuetify.week') }}
          </v-btn>
          <v-btn
            id="one_month"
            :class="{ primary: selection === 'one_month' }"
            @click="updateData('one_month')"
          >
            {{ $vuetify.lang.t('$vuetify.month') }}
          </v-btn>
          <v-btn
            id="one_year"
            :class="{ primary: selection === 'one_year' }"
            @click="updateData('one_year')"
          >
            {{ $vuetify.lang.t('$vuetify.year') }}
          </v-btn>
          <v-btn
            id="all"
            :class="{ primary: selection === 'all' }"
            @click="updateData('all')"
          >
            {{ $vuetify.lang.t('$vuetify.all') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <div v-show="mode === 'table'">
      <div
        class="mb-4"
      >
        <v-card :loading="loading">
          <v-card-title>
            {{ $vuetify.lang.t('$vuetify.generalInformation') }}
            <div class="flex-grow-1" />
            <download-group>
              <download
                format="csv"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['machineDisplayName', 'on', 'working', 'changed']
                  ),
                  [
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {on: `${$vuetify.lang.t('$vuetify.on')}/${$vuetify.lang.t('$vuetify.time')}`},
                    {working: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.working')}`},
                    {changed: `${this.$vuetify.lang.t('$vuetify.start')}/${this.$vuetify.lang.t('$vuetify.stop')}`}
                  ]
                )"
                text="csv"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-delimited
                </v-icon>
              </download>
              <download
                format="xls"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    data,
                    ['machineDisplayName', 'on', 'working', 'changed']
                  ),
                  [
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {on: `${$vuetify.lang.t('$vuetify.on')}/${$vuetify.lang.t('$vuetify.time')}`},
                    {working: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.working')}`},
                    {changed: `${this.$vuetify.lang.t('$vuetify.start')}/${this.$vuetify.lang.t('$vuetify.stop')}`}
                  ]
                )"
                text="xls"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-excel
                </v-icon>
              </download>
            </download-group>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="data"
            :loading="loading"
            :items-per-page="15"
            class="elevation-1"
          >
            <template v-slot:item.on="{ item }">
              {{ item.on }} %
            </template>

            <template v-slot:item.working="{ item }">
              {{ item.working }} %
            </template>
          </v-data-table>
        </v-card>
      </div>

      <div
        v-show="Object.keys(tableDataProduced).length > 0"
        class="my-2 headline text-center"
      >
        {{ $vuetify.lang.t('$vuetify.productionOverview') }}
      </div>
      <div
        v-for="(item, key) in tableDataProduced"
        :key="key"
        class="mb-4"
      >
        <v-card :loading="loading">
          <v-card-title>
            {{ `${$vuetify.lang.t('$vuetify.produced')}-${key}` }}
            <div class="flex-grow-1" />
            <download-group>
              <download
                format="csv"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    item,
                    ['machineDisplayName', 'produced', 'unit']
                  ),
                  [
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {produced: $vuetify.lang.t('$vuetify.produced')},
                    {unit: $vuetify.lang.t('$vuetify.unit')}
                  ]
                )"
                text="csv"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-delimited
                </v-icon>
              </download>
              <download
                format="xls"
                :json="remapperUtil.remapAsClone(
                  filterUtil.whitelistAsClone(
                    item,
                    ['machineDisplayName', 'produced', 'unit']
                  ),
                  [
                    {machineDisplayName: $vuetify.lang.t('$vuetify.machine')},
                    {produced: $vuetify.lang.t('$vuetify.produced')},
                    {unit: $vuetify.lang.t('$vuetify.unit')}
                  ]
                )"
                text="xls"
                icon-pos="left"
              >
                <v-icon>
                  mdi-file-excel
                </v-icon>
              </download>
            </download-group>
          </v-card-title>
          <v-data-table
            :headers="producedHeaders"
            :items="item"
            :loading="loading"
            :items-per-page="15"
            class="elevation-1"
          >
            <template v-slot:item.produced="{ item }">
              {{ item.produced }} {{ item.unit }}
            </template>
          </v-data-table>
        </v-card>
      </div>
    </div>
    <div v-show="mode === 'graph'">
      <div
        v-for="(item, key) in chartData"
        :key="key"
        class="mb-4"
      >
        <div v-if="ready">
          <v-card :loading="loading">
            <v-card-title>
              {{ item[0].name }}
            </v-card-title>
            <v-chart
              type="bar"
              height="350"
              :options="buildChartOptions(key, item[0])"
              :series="item"
            />
          </v-card>
        </div>
      </div>
      <div
        v-show="Object.keys(chartDataProduced).length > 0"
        class="my-2 headline text-center"
      >
        {{ $vuetify.lang.t('$vuetify.productionOverview') }}
      </div>
      <div
        v-for="(item, key) in chartDataProduced"
        :key="key"
        class="mb-4"
      >
        <div v-if="ready">
          <v-card :loading="loading">
            <v-card-title>
              {{ item[0].name }}
            </v-card-title>
            <v-chart
              type="bar"
              height="350"
              :options="buildChartOptions(key, item[0])"
              :series="item"
            />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import apiUtil from '../utils/ApiUtil';
import filterUtil from '../utils/FilterUtil';
import remapperUtil from '../utils/RemapperUtil';
import DownloadComponent from './DownloadComponent.vue';
import DownloadGroupComponent from './DownloadGroupComponent.vue';

export default {
  components: {
    'v-chart': VueApexCharts,
    download: DownloadComponent,
    downloadGroup: DownloadGroupComponent,
  },
  data: () => {
    return {
      permissionsKey: 7,
      selection: 'one_day',
      mode: 'table',
      ready: false,
      loading: false,
      data: [],
      filterUtil,
      remapperUtil,
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    chartData() {
      if (!this.data) {
        return [];
      }

      const prepared = {
        on: [{ name: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.time')}`, data: [] }],
        working: [{ name: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.working')}`, data: [] }],
        changed: [{ name: `${this.$vuetify.lang.t('$vuetify.start')}/${this.$vuetify.lang.t('$vuetify.stop')}`, data: [] }],
      };

      for (const item of this.data) {
        prepared.on[0].data.push({ x: item.machineDisplayName, y: item.on });
        prepared.working[0].data.push({ x: item.machineDisplayName, y: item.working });
        prepared.changed[0].data.push({ x: item.machineDisplayName, y: item.changed });
      }

      return prepared;
    },
    chartDataProduced() {
      if (!this.data) {
        return [];
      }

      const prepared = {};
      for (const item of this.data) {
        if (!item.machineData.tag) {
          item.machineData.tag = this.$vuetify.lang.t('$vuetify.default');
        }

        item.machineData.tagInternal = `tag_${item.machineData.tag}`;

        if (prepared[item.machineData.tag] === undefined) {
          prepared[item.machineData.tag] = [{ name: `${this.$vuetify.lang.t('$vuetify.produced')}-${item.machineData.tag}`, data: [], meta: item.machineData }];
        }

        prepared[item.machineData.tag][0].data.push({ x: item.machineDisplayName, y: (item.input1 * item.machineData.factor) });
      }

      return prepared;
    },
    tableDataProduced() {
      if (!this.data) {
        return [];
      }

      const prepared = {};
      for (const item of this.data) {
        if (!item.machineData.tag) {
          item.machineData.tag = this.$vuetify.lang.t('$vuetify.default');
        }

        item.machineData.tagInternal = `tag_${item.machineData.tag}`;

        if (prepared[item.machineData.tag] === undefined) {
          prepared[item.machineData.tag] = [];
        }

        prepared[item.machineData.tag].push({ machineDisplayName: item.machineDisplayName, unit: item.machineData.unit, produced: (item.input1 * item.machineData.factor) });
      }

      return prepared;
    },
    headers() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.machine'), value: 'machineDisplayName' },
        { text: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.time')}`, value: 'on' },
        { text: `${this.$vuetify.lang.t('$vuetify.on')}/${this.$vuetify.lang.t('$vuetify.working')}`, value: 'working' },
        { text: `${this.$vuetify.lang.t('$vuetify.start')}/${this.$vuetify.lang.t('$vuetify.stop')}`, value: 'changed' },
      ];
    },
    producedHeaders() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.machine'), value: 'machineDisplayName' },
        { text: this.$vuetify.lang.t('$vuetify.produced'), value: 'produced' },
      ];
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.updateData('one_day');
    setTimeout(() => {
      this.ready = true;
      this.$store.dispatch('setGlobalLoading', false);
    }, 100);
  },
  methods: {
    async updateData(selection) {
      this.selection = selection;
      this.loading = true;
      switch (selection) {
        case 'one_day':
          this.data = await apiUtil.getDailySumStat();
          break;
        case 'one_month':
          this.data = await apiUtil.getMonthlySumStat();
          break;
        case 'one_week':
          this.data = await apiUtil.getWeeklySumStat();
          break;
        case 'one_year':
          this.data = await apiUtil.getYearlySumStat();
          break;
        case 'all':
          this.data = await apiUtil.getAllSumStat();
          break;
        default:
      }
      this.loading = false;
    },
    buildChartOptions(mode, item) {
      const chartOptions = {
        colors: [],
        toolbar: {
          show: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {},
        },
      };

      if (mode === 'on') {
        chartOptions.colors.push('#E57373');
        chartOptions.yaxis.title.text = `${this.$vuetify.lang.t('$vuetify.percent')} %`;
        chartOptions.tooltip.y = {
          formatter(val) {
            return `${val} %`;
          },
        };
      }
      if (mode === 'working') {
        chartOptions.colors.push('#81C784');
        chartOptions.yaxis.title.text = `${this.$vuetify.lang.t('$vuetify.percent')} %`;
        chartOptions.tooltip.y = {
          formatter(val) {
            return `${val} %`;
          },
        };
      }
      if (mode === 'changed') {
        chartOptions.colors.push('#FFB74D');
        chartOptions.yaxis.title.text = '';
      }

      if (item.meta && item.meta.tagInternal.indexOf('tag_') >= 0) {
        chartOptions.colors.push('#64B5F6');
        chartOptions.yaxis.title.text = item.meta.unit ? item.meta.unit : '';
        chartOptions.tooltip.y = {
          formatter(val) {
            const unit = item.meta.unit ? item.meta.unit : '';
            return `${val} ${unit}`;
          },
        };
      }

      if (!chartOptions.colors.length) {
        chartOptions.colors.push('#796efd');
      }

      return chartOptions;
    },
  },
};
</script>
